import React from 'react';
import { graphql } from 'gatsby';
import BlogLayout from './blog-layout';
import { IArticlesData } from '@vitl-services/interfaces/blog';

interface IProps {
  data: {
    directus: {
      blog_articles: IArticlesData;
    };
  };
  pageContext: {
    numPages: number;
    slug: string;
    currentPage: number;
  };
}

const BlogArticlesList = ({ data, pageContext }: IProps) => {
  const articlesData = data?.directus?.blog_articles;

  return <BlogLayout {...{ articlesData, pageContext }} />;
};

export const query = graphql`
  query ($offset: Int!, $limit: Int!) {
    directus {
      blog_articles(
        filter: { status: { _eq: "published" } }
        sort: "-date_published"
        limit: $limit
        offset: $offset
      ) {
        id
        name
        date_published
        content
        image {
          filename_disk
        }
        author {
          name
        }
        preview
        slug
      }
    }
  }
`;

export default BlogArticlesList;
